import { Grid } from '@material-ui/core'
import styled from 'styled-components/macro'

export const Container = styled(Grid)`
    .input-_-container {
        padding: 10px;
    }
`
